import * as Yup from 'yup';
import { NOTE_ALLOWED_PATTERN, NOTE_MAX_LENGTH } from '../resources/common/DocumentNoteField';
import { DEFAULT_VALIDATION_MESSAGES } from '../hooks/useTranslatedMessages';

const defaultMessages = DEFAULT_VALIDATION_MESSAGES;

export const getDocumentNoteSchema = (messages = defaultMessages, messageKey = 'invoice') => {
  const m = messages[messageKey] || defaultMessages[messageKey] || {};

  return Yup.string()
    .max(NOTE_MAX_LENGTH, m.note_max_length)
    .matches(NOTE_ALLOWED_PATTERN, m.note_invalid_chars)
    .test('not-whitespace-only', m.note_whitespace_only, (value) => {
      if (value == null || value === '') {
        return true;
      }

      return value.trim() !== '';
    })
    .notRequired();
};
